<template>
  <div class="choosecircle">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <div class="choosecirclebox">
      <div class="nochoosecircle">
        <div class="circle-cell">
          <div class="circle-cell-pic">
            <img :src="circleIconNothing" />
          </div>
          <div class="circle-cell-name">
            <div class="cname">不发到任何圈子</div>
          </div>
          <div class="circle-cell-fllow" v-if="wxzcircle">
            <button>已选择</button>
          </div>
          <div class="circle-cell-fllow circle-cell-fllowed" data-cid="0" @click.stop="getchoosecircle" v-else>
            <button>选择</button>
          </div>
        </div>
      </div>

      <div class="followtitlebox">
        <div class="followtitle">我关注的</div>
      </div>

      <div class="followmain">
        <!-- scroll-view -->
        <div class="circlebigleftbox" style="height:26.08108108108108rem;" bindscrolltolower="onReachBottom02">
          <div class="scroll-box">
            <div class="nofollowbox" v-if="nofollow">
              <div class="nofollowpic">
                <img :src="circleIconWu" />
              </div>
              <div class="nofollowtext">
                <div>抱歉，您还没有关注的圈子,</div>
                <div>将默认发布至个人动态。</div>
              </div>
              <div class="gotofollow" @click.stop="gotofollow">
                <button>立即去关注</button>
              </div>
            </div>

            <div v-else>
              <div v-for="(item,index) in myfollowcircle" :key="index">
                <div class="circle-cell">
                  <div class="circle-cell-pic">
                    <img :src="item.avatar_url" />
                  </div>
                  <div class="circle-cell-name">
                    <div class="cname">{{item.title}}</div>
                    <!--  <div class="ccontent">{{item.content}}</div>   -->
                    <div class="ccontent">柜体保养篇：吊柜的承载力一般不如下柜，所以吊柜内适合放置比较轻的物品，如调味罐及玻璃杯等重物最好**下柜里；器皿应该清洗干净后再放入柜中，特别要注意的是要把器皿**干；橱柜中的五金件用干布**，避免水滴留在其表面造成水痕；料理台的水槽可以事先用细丝兜住内部滤盒，防止菜屑及细小残渣堵住水管。清洁篇：每次清洗水槽时，要记得把滤盒后的管部颈端一并清洗，以免长期堆积的油垢愈积愈多；如果油垢长期堆积在水槽管道内不易洗净，那么试试在水槽内倒一些厨房去油渍的清洁剂，用热水冲后，再以冷水冲。</div>
                  </div>
                  <div class="circle-cell-fllow" v-if="xzcircleindex == index+1">
                    <button>已选择</button>
                  </div>
                  <div class="circle-cell-fllow circle-cell-fllowed" :data-cname="item.title" :data-cid="item.id" :data-index="index+1" @click.stop="getchoosecircle" v-else>
                    <button>选择</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getfollowcircle } from "../../api/api";
import navbar from "../public/navbar.vue";

import Vue from "vue";
import { Toast } from "vant";

// 全局注册
Vue.use(Toast);

export default {
  name: "choosecircle",
  components: { navbar },
  data () {
    return {
      titlename: "选择圈子",
      nofollow: true, //当没有关注的状态
      myfollowcircle: [], //我关注的圈子
      page: 0, //分页请求
      pageCount: null, //总页数
      isloading: true, //是否显示加载动画
      wxzcircle: true,
      xzcircleindex: null,
      circleIconNothing: require('../../assets/images/circle_icon_nothing.png'),
      circleIconWu: require('../../assets/images/circle_icon_wu.png'),
    };
  },
  created () {
    document.title = '选择圈子';
    let xzcircleindex = localStorage.getItem("xzcircleindex");

    if (xzcircleindex > 0) {
      this.wxzcircle = false;
      this.xzcircleindex = xzcircleindex;
    } else {
      this.wxzcircle = true;
      this.xzcircleindex = null;
    }

    let that = this;
    //获取关注过的圈子列表
    getfollowcircle().then(res => {
      //没有关注圈子
      if (res.data.code == 412) {
        that.nofollow = true;
        that.page = 0;
        that.pageCount = null;
      } else if (res.data.code == 200) {
        that.nofollow = false;
        that.myfollowcircle = res.data.data.list;
        that.pageCount = res.data.data.pageCount;
      }
    }).catch(err => {
    });
  },
  methods: {
    getchoosecircle (e) {
      let circleid = e.currentTarget.dataset.cid;
      let circlename = e.currentTarget.dataset.cname;
      let xzcircleindex = e.currentTarget.dataset.index;
      this.wxzcircle = false;

      localStorage.setItem("xzcircleindex", xzcircleindex);


      // 传值cid给上级
      /*       var pages = getCurrentPages();
      if (pages.length > 1) {
        var prePage = pages[pages.length - 2];
        if (circleid > 0) {
          prePage.setData({
            circleid: circleid,
            currentshow: true,
            circlename: circlename
          });
        } else {
          prePage.setData({
            circleid: circleid,
            currentshow: false,
            circlename: null
          });
        }
      } */

      if (circleid > 0) {
        /*  prePage.setData({
           circleid: circleid,
           currentshow: true,
           circlename: circlename
         }); */
        localStorage.setItem("hccirclename", circlename);
        localStorage.setItem("hccircleid", circleid);
        localStorage.setItem("currentshow", true);
      } else {
        localStorage.setItem("hccirclename", '');
        localStorage.setItem("hccircleid", circleid);
        localStorage.setItem("currentshow", false);
        /*   prePage.setData({
            circleid: circleid,
            currentshow: false,
            circlename: null
          }); */
      }



      this.$router.go(-1);
    },
    gotofollow () {
      this.$router.push({
        name: "circlelist"
      });
    }
  }
};
</script>

<style>
/* subpages/publish/choosecircle/choosecircle.wxss */
button {
  border: 0;
}
.choosecirclebox {
  border-top: 0.02702702702702703rem solid #f3f3f3;
  padding-top: 50px;
  padding-left: 0.8108108108108109rem;
  padding-right: 0.2702702702702703rem;
}
.choosecirclebox .followtitlebox {
  padding-bottom: 0.5405405405405406rem;
  background: #fff;
}
.choosecirclebox .followtitle {
  margin-top: 0.8108108108108109rem;
  font-size: 0.8108108108108109rem;
  border-left: 0.2702702702702703rem solid #ffbd0a;
  padding-left: 0.5405405405405406rem;
  font-weight: bold;
}
.choosecirclebox .followmain .scroll-box {
  padding-bottom: 1.3513513513513513rem;
}
.choosecirclebox .followmain .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
}
.choosecirclebox .followmain .circle-cell .circle-cell-pic {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  flex: 2 1 2.4324324324324325rem;
  width: 2.4324324324324325rem;
  position: relative;
}
.choosecirclebox .followmain .circle-cell .circle-cell-pic .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.108108108108108rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.choosecirclebox
  .followmain
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no
  img {
  width: 0.7567567567567568rem;
  height: 0.5675675675675675rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-name {
  width: 10.81081081081081rem;
  flex: 7 1 10.81081081081081rem;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.2702702702702703rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
  padding-bottom: 0.16216216216216217rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-name .ccontent {
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  font-size: 0.6486486486486487rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-fllow {
  padding-top: 0.2702702702702703rem;
  flex: 1 1 4.054054054054054rem;
  width: 4.054054054054054rem;
}
.choosecirclebox .followmain .circle-cell .circle-cell-fllow button {
  font-size: 0.6486486486486487rem;
  border: 1px solid #ffbd0a;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffffff;
  padding: 0;
  color: #ffbd0a;
  border-radius: 5px;
  margin: 0 auto;
}
button:after {
  border: none;
}
.choosecirclebox .followmain .circle-cell .circle-cell-fllowed button {
  font-size: 0.6486486486486487rem;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffbd0a;
  padding: 0;
  color: #fff;
  border-radius: 5px;
  margin: 0 auto;
}
.choosecirclebox .nochoosecircle .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-pic {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  flex: 2 1 2.4324324324324325rem;
  width: 2.4324324324324325rem;
  position: relative;
}
.choosecirclebox
  .nochoosecircle
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.108108108108108rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-name {
  width: 10.81081081081081rem;
  flex: 7 1 10.81081081081081rem;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.2702702702702703rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
  padding-top: 0.5135135135135135rem;
  padding-bottom: 0.16216216216216217rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-fllow {
  padding-top: 0.2702702702702703rem;
  flex: 1 1 4.054054054054054rem;
  width: 4.054054054054054rem;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-fllow button {
  font-size: 0.6486486486486487rem;
  border: 1px solid #ffbd0a;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffffff;
  padding: 0;
  color: #ffbd0a;
  border-radius: 5px;
  margin: 0 auto;
}
.choosecirclebox .nochoosecircle .circle-cell .circle-cell-fllowed button {
  font-size: 0.6486486486486487rem;
  width: 3.2432432432432434rem;
  line-height: 1.5rem;
  display: block;
  color: #fff;
  background: #ffbd0a;
  padding: 0;
  color: #fff;
  border-radius: 5px;
  margin: 0 auto;
}
button:after {
  border: none;
}
.choosecirclebox .nofollowbox {
  padding-top: 5.405405405405405rem;
}
.choosecirclebox .nofollowbox .nofollowtext {
  text-align: center;
  padding-top: 0.8108108108108109rem;
  color: #999;
  font-size: 0.72rem;
}
.choosecirclebox .nofollowbox .nofollowpic {
  text-align: center;
}
.choosecirclebox .nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.choosecirclebox .nofollowbox .gotofollow {
  padding-top: 1.2702702702702702rem;
  text-align: center;
}
.choosecirclebox .nofollowbox .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7567567567567568rem;
  color: #fff;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/choosecircle.vue